module.exports = __webpack_public_path__ + "media/images/icons/v2/log-out-01-6999917d74ab87d8aaaaf350dd28d1d2.svg";